import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Grid, Group, Space, ThemeIcon, Title, } from "@mantine/core";
import { IconEye } from "@tabler/icons-react";
import { RefreshButton, RefreshButtonRef } from "../../components/customer_instant_search";
import IposInstantSearch from "./ipos_instant_search";
import { IpoRequestObject } from "../../types";



interface ActionsComponentProps {
  ipoObj: IpoRequestObject;
}


const RenderActions = ({ ipoObj }: ActionsComponentProps) => {

  const navigate = useNavigate();

  return <Group>


    <ThemeIcon color="blue" variant="light" onClick={() => {
      navigate("/ipo-requests/" + ipoObj.id, { state: ipoObj })
    }}><IconEye size={16} /></ThemeIcon>


  </Group>

}
const IpoRequestsList = () => {



  const [selectedRows, setSelectedRows] = useState([]);


  const location = useLocation();

  const { refreshIposIn } = location.state || {};


  const refreshRef = useRef<RefreshButtonRef | null>(null);

  const handleExternalRefresh = () => {
    if (refreshRef.current) {
      refreshRef.current.refresh();
    }
  };


  useEffect(() => {
    if (refreshIposIn) {
      const timer = setTimeout(() => {
        // Action to perform after delay
        console.log('Refreshing ipos...');
        handleExternalRefresh();
        // Place your code here to refresh ipos or any other intended action
      }, refreshIposIn);

      // Clean up the timer when the component unmounts or if the value of refreshIposIn changes
      return () => clearTimeout(timer);
    }
  }, [refreshIposIn]); // Dependency array, re-run effect if refreshIposIn changes



  const searchableIpos = useMemo(() => <IposInstantSearch
    setSelectedRows={setSelectedRows}
    selectable={true}
    selectedRows={selectedRows}
    renderTags={true}
    navigateDetails={(obj: any) => {


    }
    }
    ActionsComponent={RenderActions}
    indexName={import.meta.env.VITE_TYPESENSE_IPOS_COLLECTION!}

    additionalChildren={<RefreshButton ref={refreshRef} />}




  />,
    // eslint-disable-next-line 
    [selectedRows]);



  return (
    <>
      <Group justify="space-between">
        <Title>Ipo Requests</Title>

      </Group>
      <Space h="xl" />
      {/* <Card shadow="sm" p="lg" radius="md" withBservice> */}
      <Card shadow="sm" p="lg" radius="md" withBorder>
        <Grid justify="space-between">
          <Grid.Col>

          </Grid.Col>
          <Grid.Col>
            {searchableIpos}
          </Grid.Col>
        </Grid>
      </Card>



    </>
  );
};


const IposRequests = () => {
  return (
    <main style={{ padding: "1rem 0" }}>
      <IpoRequestsList />

    </main>
  );
};

export default IposRequests;
